import { render, staticRenderFns } from "./AuctionTermsWrapper.vue?vue&type=template&id=30344f0d&"
import script from "./AuctionTermsWrapper.vue?vue&type=script&lang=js&"
export * from "./AuctionTermsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports